module.exports = __webpack_public_path__ + "rural.jpg?50c0b1d4179346949a721f6879250554";